import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormLayoutComponent } from '../form-layout/form-layout.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlParamsService } from '../../services/url-params.service';

@Component({
  selector: 'app-error',
  imports: [FormLayoutComponent],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  errorMessage: string | null = null;

  constructor(private urlParamsService: UrlParamsService) {}

  ngOnInit(): void {
    this.errorMessage = this.urlParamsService.getErrorMessage();
    if (!this.errorMessage) {
      this.errorMessage = '404 Page not found';
    }
    this.urlParamsService.clearErrorMessage();
  }
}
